<template>
  <one-column-layout :container="false" ref="layout">

    <v-app-bar
      slot="navbar"
      app
      fixed
      clipped-left
    >
      <div class="d-flex align-center">
        <div
        :style="{
          display: 'flex',
          marginLeft: '1rem',
          marginRight: '1.5rem',
        }">
        <img
          v-if="!this.$vuetify.breakpoint.smAndDown"
          class="cursor--point"
          alt="Junta de Andalucia"
          :style="{maxWidth: '43px'}"
          src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/sites/default/files/repositorio/2025-11/logo-junta.svg"
          :width="$vuetify.breakpoint.smAndDown ? 110 : 190"
          @click="maybeGoJunta()"
        />
        <img
          v-if="!this.$vuetify.breakpoint.smAndDown"
          class="cursor--point"
          alt="Junta de Andalucia"
          :style="{maxWidth: '150px', width: '115px', marginLeft: '8px'}"
          src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/repositorio/logotipo-sas"
          :width="$vuetify.breakpoint.smAndDown ? 110 : 190"
          @click="maybeGoSAS()"
        />
      </div>
        <v-img
          alt="Ayuda Digital Logo"
          class="shrink mr-2 cursor--point"
          contain
          src="@/assets/logo_large.png"
          :width="$vuetify.breakpoint.smAndDown ? 110 : 190"
          @click="maybeGoToAyudaDigital()"
        />
      </div>

      <v-spacer />

      <v-btn
        v-if="!isSignedIn"
        :href="route"
        outlined
        color="white"
        :style="{background:'#27846d'}"
      >
        {{ $t('views.login.signin') }}
      </v-btn>

    </v-app-bar>

    <router-view></router-view>
    <Messages
      id="messages-panel"
      :messages="messages"
      :style="{ top: ($refs.header ? $refs.header.$el.style.height : '64px')  }"
      v-bind:class="{ 'pa-0': !messages.length }"
    ></Messages>
  </one-column-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { OneColumnLayout } from '@/layouts';
import { Messages } from '../components';

export default {
  name: 'PublicView',
  components: {
    OneColumnLayout,
    Messages,
  },
  computed: {
    ...mapState({
      messages: ({ messages: { list } }) => list,
    }),
    ...mapGetters({
      isSignedIn: 'session/isSignedIn',
    }),
    route() {
      const route = (this.$route.params || {}).redirect;
      return route ? `${this.$router.options.base}login?redirect=${route}` : `${this.$router.options.base}login`;
    },
    isMobile() {
      if (window.flutter_inappwebview) {
        return true;
      }
      if (this.$route.query.mobile) {
        return true;
      }
      return false;
    },
  },
  methods: {
    maybeGoSAS() {
      const servicioAndaluzSalud = 'https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/';
      window.open(servicioAndaluzSalud, '_blank');
    },
    maybeGoJunta() {
      const servicioAndaluzSalud = 'https://www.juntadeandalucia.es/';
      window.open(servicioAndaluzSalud, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  $messages-panel-width: 400px;
  $messages-panel-padding: 1rem;

  #messages-panel {
    position: fixed;
    right: 0;
    width: $messages-panel-width;
    max-width: 100%;
    padding: $messages-panel-padding;
  }
</style>
